<button
  mat-flat-button
  class="custom-button"
  [class.custom-button--loading]="loading"
  [color]="isThemeColor ? color : null"
  [style.background-color]="
    disabled ? disabledBgColor : !isThemeColor ? color : null
  "
  [style.color]="disabled ? disabledTextColor : textColor || null"
  [disabled]="disabled"
>
  <span class="custom-button__content">
    @if (loading) {
    <mat-spinner class="custom-button__spinner" diameter="18"></mat-spinner>
    } @else if (icon) {
    <mat-icon aria-hidden="false" [attr.aria-label]="icon">{{ icon }}</mat-icon>
    } @else if (img) {
    <img [src]="img" alt="icon" />
    }

    <ng-content></ng-content>
  </span>
</button>
